module.exports = __webpack_public_path__ + "resources/stickers-d5d3db8fd03550094417ecf5d64e5cdd.svg";